// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfb_a bib_bj"};